
import { schema } from "./types";
import { IAutomationAppComponent } from "../../../types";
import { OverviewPanel, OperatorPanel, ConfigurationPanel } from '.';
import { ListPanel } from "./ListPanel";
import { SiGoogleoptimize }  from "react-icons/si";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: false,
    Icon: SiGoogleoptimize,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    ListPanel: ListPanel,
    isSmartApp: true,
    createConfig:     {
        group: "Plants",
        name: "A optimizer for the pressure in air handling units",
        description: "Optimizer for the pressure in air handling units",
        panel: OverviewPanel,
        defaultState: {},
        defaultProperties: [
            { key: 'OutMin', value: '300' },
            { key: 'OutMax', value: '500' },
            { key: 'SetpointHeat', value: '22' },
            { key: 'SetpointCool', value: '25' },
            { key: 'SetpointAQ', value: '600' },
        ]
    },
}